import React from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Mail,
  PhoneCall,
  MapPin,
} from 'lucide-react';

import {
  FaFacebookF,
  FaInstagram,
} from 'react-icons/fa';

export const Footer: React.FC = () => {
  return (
    <footer className="text-white bg-gray-800">
      <div className="container px-4 py-12 mx-auto">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="p-2 mr-2 text-white rounded-lg bg-primary">
                <Calendar size={24} />
              </div>
              <span className="text-xl font-bold">fixionity</span>
            </div>
            <p className="mb-4 text-gray-300">
              Conectando a quienes lo necesitan con equipos de rehabilitación de alta calidad para mejores resultados en salud.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 transition hover:text-white">
                <FaFacebookF size={20} />
              </a>
              <a href="#" className="text-gray-300 transition hover:text-white">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* For Renters */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Para Inquilinos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/search" className="text-gray-300 transition hover:text-white">Buscar Equipos</Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-300 transition hover:text-white">Cómo Funciona</Link>
              </li>
              <li>
                <Link to="/insurance" className="text-gray-300 transition hover:text-white">Cobertura de Seguro</Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-300 transition hover:text-white">Recursos de Rehabilitación</Link>
              </li>
              <li>
                <Link to="/help" className="text-gray-300 transition hover:text-white">Centro de Ayuda</Link>
              </li>
            </ul>
          </div>

          {/* For Equipment Owners */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Sobre Fixionity</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/our-mission" className="text-gray-300 transition hover:text-white">Nuestra misión</Link>
              </li>
              <li>
                <Link to="/team" className="text-gray-300 transition hover:text-white">El equipo detrás del proyecto</Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 transition hover:text-white">Blog</Link>
              </li>
              <li>
                <Link to="/partnerships" className="text-gray-300 transition hover:text-white">Partners y aliados</Link>
              </li>
              <li>
                <Link to="/certifications" className="text-gray-300 transition hover:text-white">Certificaciones</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Contáctanos</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="mt-1 text-gray-300 shrink-0" />
                <span className="text-gray-300">123 Healing Street, Health City, HC 10001</span>
              </li>
              <li className="flex items-center space-x-3">
                <PhoneCall size={20} className="text-gray-300" />
                <span className="text-gray-300">(555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="text-gray-300" />
                <span className="text-gray-300">support@fixionity.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between pt-8 mt-8 border-t border-gray-700 md:flex-row">
          <p className="mb-4 text-sm text-gray-400 md:mb-0">
            &copy; {new Date().getFullYear()} Fixionity. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-400">
            <Link to="/terms" className="mb-2 hover:text-white md:mb-0">Términos de Servicio</Link>
            <Link to="/privacy" className="mb-2 hover:text-white md:mb-0">Política de Privacidad</Link>
            <Link to="/accessibility" className="mb-2 hover:text-white md:mb-0">Accesibilidad</Link>
            <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};